import { useQuery } from '@tanstack/react-query'
import { VirtualCardAPI } from '@apis'

export const useUserCredits = (userId: string | undefined | null) => {
    return useQuery({
        queryKey: ['user-credits', userId],
        queryFn: async () => {
            if (!userId) return null
            try {
                return await VirtualCardAPI.GetUserCreditsRequest.fetch(userId)
            } catch (error) {
                console.error('Failed to fetch user credits:', error)
                return null
            }
        },
        enabled: !!userId,
    })
}
